<template>
  <transition name="toast-fade">
    <div v-if="show" ref="toastRef" class="bottom-toast">
      <span v-if="icon" class="toast-icon" v-html="icon"></span>
      <span class="toast-content">{{ message }}</span>
    </div>
  </transition>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import gsap from 'gsap'

const props = defineProps({
  show: Boolean,
  message: { type: String, default: '' },
  type: { type: String, default: 'info' }
})

const icon = computed(() => ({
  success: '✅',
  error:   '❌',
  warning: '⚠️',
  info:    ''
}[props.type] || ''))

const toastRef = ref(null)

watch(() => props.show, (show) => {
  if (!toastRef.value) return
  if (show) {
    gsap.fromTo(toastRef.value, { y: 40, scale: 0.96, opacity: 0 }, {
      y: 0, scale: 1, opacity: 1, duration: 0.44, ease: 'back.out(1.6)'
    })
  } else {
    gsap.to(toastRef.value, {
      y: 32, scale: 0.97, opacity: 0, duration: 0.32, ease: 'power2.in'
    })
  }
})
</script>

<style scoped>
.bottom-toast {
  position: fixed;
  left: 50%;
  bottom: 7vmin;
  transform: translateX(-50%);
  min-width: 28vmin;
  max-width: 90vw;
  /* 只用图片，绝不加深色/阴影/圆角，边界全部靠图！ */
  background: url('https://joygma.online/ui/system/toast_bg.png') center/100% 100% no-repeat;
  color: var(--pw-text); /* 深咖，适配你这图片的文字色 */
  padding: 1.2em 3.2em;
  font-size: clamp(16px, 3vmin, 30px);
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
  pointer-events: none;
  user-select: none;
  box-shadow: 0 4px 18px #0003; /* 只加立体感，不抢戏 */
  border: none;
  border-radius: 0;
  opacity: 1;
  /* 过渡只是兜底，实际由gsap控制 */
  transition: opacity 0.18s;
}

.toast-icon {
  margin-right: 1.4em;
  font-size: clamp(16px, 3.4vmin, 34px);
  filter: drop-shadow(0 0 2px #fff4);
}
.toast-content {
  word-break: break-all;
  letter-spacing: 0.02em;
  text-shadow: none;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.34s cubic-bezier(.4,0,.2,1), transform 0.32s cubic-bezier(.4,0,.2,1);
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(30px) scale(0.96);
}
</style>
